import React from "react";
import clsx from "clsx";
import { Schema } from "../../../configuration/common-models/CommonModelToggleTypes";
import { Text, CopyIcon } from "@merge-api/merge-javascript-shared";
import { Italic, Menu } from "lucide-react";

type MissingFieldsListProps = {
  missingFields: string[];
  modelSchema: Schema;
  isLoading?: boolean;
};

const getIconForType = (type: string | undefined) => {
  if (type?.endsWith("[]") || type === "Array" || type === "Object") {
    return <Menu size={12} className="text-gray-40" />;
  }
  return <Italic size={12} className="text-gray-40" />;
};

const MissingFieldsList = ({ missingFields, modelSchema, isLoading }: MissingFieldsListProps) => {
  if (isLoading) {
    return <Text variant="sm">Loading...</Text>;
  }

  const commaSeparatedFields = missingFields.join(", ");

  return (
    <div className="flex flex-col -mx-3 -my-2 overflow-hidden max-h-[218px]">
      <div className="flex items-center justify-between px-4 pt-2 pb-1">
        <Text variant="title-sm">Inaccessible Common Model fields</Text>
        <CopyIcon size={12} text={commaSeparatedFields} className="text-gray-40 shrink-0" />
      </div>
      <div className="relative">
        <div className="pointer-events-none absolute top-0 left-0 right-0 h-3 bg-gradient-to-b from-white to-transparent z-10" />
        <div className="overflow-auto max-h-[180px] flex flex-col px-4">
          {missingFields.map((missingField, index) => {
            const missingFieldParameters =
              modelSchema && modelSchema["parameters"] && modelSchema["parameters"][missingField];

            if (!missingFieldParameters) {
              return null;
            }
            const isLastRow = index === missingFields.length - 1;
            return (
              <div className="flex" key={missingField}>
                <div className="flex flex-col items-center">
                  <div
                    className={clsx(
                      "flex-1",
                      index === 0 ? "border-l-0" : "border-l border-gray-10",
                    )}
                  />
                  <div className="w-6 h-6 rounded-full border border-gray-10 flex items-center justify-center bg-white shrink-0">
                    {getIconForType(missingFieldParameters?.type)}
                  </div>
                  <div
                    className={clsx("flex-1", isLastRow ? "border-l-0" : "border-l border-gray-10")}
                  />
                </div>
                <div
                  className={clsx(
                    "flex items-center flex-grow py-2 ml-3 whitespace-nowrap",
                    !isLastRow && "border-b border-gray-10",
                  )}
                >
                  <Text variant="sm-mono" className="mr-2">
                    {missingField}
                  </Text>
                  <Text variant="sm" className="text-gray-40">
                    {missingFieldParameters?.type}
                  </Text>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
export default MissingFieldsList;
